var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 15.8333V5.16667C3.3335 4.23325 3.3335 3.76653 3.51515 3.41002C3.67494 3.09641 3.9299 2.84144 4.24351 2.68166C4.60003 2.5 5.06675 2.5 6.00016 2.5H14.0002C14.9336 2.5 15.4003 2.5 15.7568 2.68166C16.0704 2.84144 16.3254 3.09641 16.4852 3.41002C16.6668 3.76653 16.6668 4.23325 16.6668 5.16667V14.1667H5.00016C4.07969 14.1667 3.3335 14.9128 3.3335 15.8333ZM3.3335 15.8333C3.3335 16.7538 4.07969 17.5 5.00016 17.5H16.6668M7.50016 5.83333H12.5002M7.50016 9.16667H12.5002M15.8335 14.1667V17.5",
    stroke: "url(#paint0_linear_1798_40865)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40865",
    x1: 10.0002,
    y1: 2.5,
    x2: 10.0002,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceBookIcon);
export default __webpack_public_path__ + "static/media/price-book-icon.2557c6cfa0712c175094d9f0d27c4a1f.svg";
export { ForwardRef as ReactComponent };